import React, { useEffect, useRef, useState } from "react";
import "./styles/Topics.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useAuth0 } from "@auth0/auth0-react";
import { useEnv } from "../../context/env.context";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const Topics = ({ setStep, me }) => {
  const [showIntro, setShowIntro] = useState(true);
  const { getAccessTokenSilently } = useAuth0();
  const { apiServerUrl } = useEnv();
  const [activeGoal, setActiveGoal] = useState("");
  const history = useHistory();

  const [active, setActive] = useState("topic");

  const [topic, setTopic] = useState({
    topic: null,
    important: null,
    walk_away: null,
  });

  useEffect(() => {
    getMe();
    const nav = document.getElementsByClassName("nav-bar__container")[0];
    if (nav) {
      nav.style = "display:none";
    }

    const container = document.getElementsByClassName("content_container")[0];
    if (container) {
      container.style = "max-width: 100%;width:100%;";
    }

    return () => {
      const nav = document.getElementsByClassName("nav-bar__container")[0];
      if (nav) {
        nav.style = "display:flex";
      }

      const container = document.getElementsByClassName("content_container")[0];
      if (container) {
        container.style = "max-width: 100%;width:100%;";
      }
    };
  }, []);

  const saveTopics = async () => {
    const token = await getAccessTokenSilently();

    const config = {
      url: `${apiServerUrl}/api/topics`,
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: topic,
    };

    config.headers = {
      Authorization: `Bearer ${token}`,
    };

    const response = await axios(config);

    history.push("/tying/dashboard");

  };

  const getMe = async () => {
    try {
      const token = await getAccessTokenSilently();

      const config = {
        url: `${apiServerUrl}/api/users/me`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios(config);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  return (
    <div className="chooseTopics">
      <div className="sidebar">
        <div className="title">
          <FontAwesomeIcon
            icon={faTimes}
            onClick={() => {
              setStep(0);
            }}
          />

          <h3>Tying it All Together</h3>
        </div>

        <div className="inner">
          {active === "topic" && (
            <>
              <div className="subtitle">
                <h4>What topic would you like coaching on?</h4>
                <p>
                  You will be bringing this to your next session to discuss.
                </p>
                <textarea
                  value={topic.topic || ""}
                  onChange={(e) => {
                    setTopic({ ...topic, topic: e.target.value });
                  }}
                  placeholder="Type your response here"
                ></textarea>
              </div>
            </>
          )}

          {active === "important" && (
            <>
              <div className="subtitle">
                <h4>What's important about this topic?</h4>
                <p>
                  You will be bringing this to your next session to discuss.
                </p>
                <textarea
                  value={topic.important || ""}
                  onChange={(e) => {
                    setTopic({ ...topic, important: e.target.value });
                  }}
                  placeholder="Type your response here"
                ></textarea>
              </div>
            </>
          )}

          {active === "walk_away" && (
            <>
              <div className="subtitle">
                <h4>
                  What do you want to walk away with at the end of the session?
                </h4>
                <p>
                  You will be bringing this to your next session to discuss.
                </p>
                <textarea
                  value={topic.walk_away || ""}
                  onChange={(e) => {
                    setTopic({ ...topic, walk_away: e.target.value });
                  }}
                  placeholder="Type your response here"
                ></textarea>
              </div>
            </>
          )}

          <div className="bottom">
            <button onClick={()=>{
              if (active === "topic") {
                history.push("/tying");
              } else if (active === "important") {
                setActive("topic");
              } else {
               setActive("important");
              }
            }} className="btn blank">Back</button>
            <button
              disabled={topic[active] === null || topic[active] === ""}
              onClick={() => {
                if (active === "topic") {
                  setActive("important");
                } else if (active === "important") {
                  setActive("walk_away");
                } else {
                  saveTopics();
                }
              }}
              className="btn secondary"
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      <div className="right">
        <div className="white-background">
          <h3>Career Topic</h3>
          <p>What topic would you like coaching on?</p>

          <div className="topic">
            <h3>What topic would you like coaching on?</h3>
            <div className="box">
              <p>{topic.topic || "Response goes here"}</p>
            </div>
          </div>

          <div
            className={`topic ${topic.important !== null ? "active" : "hide"}`}
          >
            <h3>What's important about this topic?</h3>
            <div className="box">
              <p>{topic.important || "Response goes here"}</p>
            </div>
          </div>

          <div
            className={`topic ${topic.walk_away !== null ? "active" : "hide"}`}
          >
            <h3>
              What do you want to walk away with at the end of the session?
            </h3>
            <div className="box">
              <p>{topic.walk_away || "Response goes here"}</p>
            </div>
          </div>
        </div>
      </div>
      {showIntro && (
        <div className="modal">
          <div className="modal-content">
            <div className="left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M29.3342 62.1056C29.0081 61.4882 28.6049 60.9147 28.1342 60.3989C27.4404 59.7446 26.6808 59.1637 25.8675 58.6656C26.7687 57.7316 27.4589 56.6149 27.8913 55.3912C28.3238 54.1675 28.4884 52.8651 28.3742 51.5723C28.3742 50.4682 28.1559 49.375 27.7318 48.3556C27.3076 47.3362 26.6861 46.4107 25.9029 45.6325C25.1197 44.8542 24.1903 44.2386 23.1683 43.8209C22.1462 43.4033 21.0516 43.1919 19.9475 43.1989C17.5984 43.1325 15.3158 43.9835 13.5835 45.5714C11.8511 47.1594 10.8052 49.3596 10.6675 51.7056C10.6099 53.199 10.9908 54.6767 11.7632 55.9562C12.5357 57.2357 13.6658 58.261 15.0142 58.9056C13.9113 59.4893 12.8666 60.1769 11.8942 60.9589C10.9311 61.7645 10.1029 62.7187 9.44087 63.7856C8.83041 64.706 8.41186 65.7401 8.21025 66.826C8.00865 67.912 8.02813 69.0274 8.26754 70.1056C8.29937 70.339 8.4226 70.5502 8.61014 70.6927C8.79768 70.8352 9.03415 70.8974 9.26754 70.8656C9.50093 70.8338 9.71212 70.7105 9.85465 70.523C9.99717 70.3355 10.0594 70.099 10.0275 69.8656C10.0292 68.6378 10.4009 67.439 11.0942 66.4256C11.7481 65.4217 12.4983 64.4839 13.3342 63.6256C14.6142 62.1856 16.0009 60.7456 17.0942 59.6523C17.8958 59.859 18.7197 59.9665 19.5475 59.9723C19.6491 59.9795 19.7512 59.9666 19.8478 59.9343C19.9444 59.902 20.0337 59.8509 20.1105 59.784C20.1873 59.7171 20.2501 59.6357 20.2954 59.5445C20.3407 59.4532 20.3674 59.3539 20.3742 59.2523C20.3815 59.1507 20.3686 59.0486 20.3363 58.952C20.304 58.8554 20.2529 58.7661 20.186 58.6893C20.1191 58.6125 20.0377 58.5497 19.9464 58.5044C19.8551 58.4591 19.7558 58.4324 19.6542 58.4256C14.9609 57.9456 12.9342 54.8789 13.1742 51.8389C13.3562 50.1717 14.1776 48.6399 15.4656 47.5657C16.7537 46.4915 18.408 45.9586 20.0809 46.0789C21.6066 46.0502 23.082 46.6254 24.1857 47.6792C25.2895 48.733 25.9323 50.1801 25.9742 51.7056C26.2905 53.2607 25.9806 54.8778 25.1119 56.2058C24.2432 57.5338 22.8857 58.4656 21.3342 58.7989C21.2168 58.8085 21.1027 58.8422 20.999 58.898C20.8953 58.9537 20.8043 59.0304 20.7317 59.1231C20.659 59.2157 20.6063 59.3224 20.577 59.4365C20.5476 59.5505 20.5421 59.6694 20.5609 59.7856C20.5877 60.0145 20.7033 60.2238 20.8828 60.3684C21.0624 60.5131 21.2915 60.5814 21.5209 60.5589C22.4468 60.4523 23.3482 60.1909 24.1875 59.7856C24.8143 60.5305 25.3932 61.3142 25.9209 62.1323L26.8009 63.5723C27.0675 64.0789 27.3609 64.5589 27.6275 65.0923C28.3071 66.3294 28.8781 67.6232 29.3342 68.9589C29.353 69.0747 29.3955 69.1854 29.459 69.284C29.5224 69.3826 29.6056 69.4671 29.7032 69.5322C29.8008 69.5972 29.9107 69.6415 30.0262 69.6621C30.1416 69.6828 30.2601 69.6794 30.3742 69.6523C30.6011 69.601 30.7997 69.4644 30.9287 69.2708C31.0578 69.0772 31.1075 68.8415 31.0675 68.6123C30.9495 67.0416 30.636 65.4919 30.1342 63.9989C29.9321 63.3425 29.664 62.7081 29.3342 62.1056Z"
                  fill="#FF9E67"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M71.1734 63.9976C70.9644 63.331 70.6874 62.6876 70.3467 62.0776C70.0021 61.4652 69.5907 60.8928 69.1201 60.3709C68.4538 59.6842 67.7112 59.0758 66.9067 58.5576C67.7901 57.6198 68.4634 56.5044 68.8818 55.2859C69.3003 54.0673 69.4542 52.7736 69.3334 51.4909C69.3299 50.3878 69.1092 49.2962 68.6838 48.2784C68.2584 47.2606 67.6367 46.3366 66.8542 45.559C66.0718 44.7815 65.1438 44.1657 64.1233 43.7468C63.1028 43.3279 62.0098 43.1141 60.9067 43.1176C58.5346 43.0444 56.2278 43.9015 54.479 45.5058C52.7301 47.1102 51.6778 49.3346 51.5467 51.7043C51.5087 53.2074 51.9097 54.689 52.7006 55.9678C53.4916 57.2466 54.6382 58.267 56.0001 58.9043C54.8971 59.488 53.8524 60.1755 52.8801 60.9576C51.9169 61.7632 51.0887 62.7174 50.4267 63.7843C49.8047 64.6993 49.3793 65.7334 49.1774 66.8213C48.9754 67.9091 49.0013 69.027 49.2534 70.1043C49.2571 70.2277 49.2868 70.349 49.3405 70.4603C49.3942 70.5715 49.4707 70.6702 49.5651 70.7499C49.6594 70.8296 49.7695 70.8886 49.8881 70.9229C50.0068 70.9573 50.1313 70.9663 50.2537 70.9494C50.376 70.9324 50.4934 70.8899 50.5983 70.8246C50.7031 70.7593 50.793 70.6726 50.8622 70.5703C50.9313 70.4679 50.9781 70.3522 50.9996 70.2305C51.0211 70.1089 51.0167 69.9841 50.9867 69.8643C50.9979 68.6339 51.3788 67.4353 52.0801 66.4243C52.7339 65.4203 53.4841 64.4826 54.3201 63.6243C55.6001 62.1843 56.9867 60.7443 58.0534 59.651C58.8641 59.8575 59.6968 59.9649 60.5334 59.9709C60.6349 59.9709 60.7355 59.9509 60.8293 59.9121C60.9232 59.8732 61.0084 59.8163 61.0802 59.7444C61.152 59.6726 61.209 59.5874 61.2479 59.4936C61.2867 59.3997 61.3067 59.2992 61.3067 59.1976C61.3067 59.0961 61.2867 58.9955 61.2479 58.9017C61.209 58.8078 61.152 58.7226 61.0802 58.6508C61.0084 58.579 60.9232 58.522 60.8293 58.4831C60.7355 58.4443 60.6349 58.4243 60.5334 58.4243C55.8401 57.9443 53.8134 54.8776 54.0534 51.8376C54.2354 50.1704 55.0568 48.6386 56.3448 47.5644C57.6329 46.4902 59.2872 45.9573 60.9601 46.0776C62.4858 46.0489 63.9612 46.6241 65.0649 47.6779C66.1687 48.7317 66.8115 50.1788 66.8534 51.7043C67.1676 53.2708 66.8469 54.8979 65.9618 56.228C65.0767 57.5582 63.6997 58.4824 62.1334 58.7976C61.9022 58.8308 61.6928 58.952 61.5487 59.1358C61.4047 59.3196 61.3371 59.5519 61.3601 59.7843C61.3933 60.0154 61.5144 60.2249 61.6982 60.3689C61.882 60.513 62.1143 60.5806 62.3467 60.5576C63.2726 60.451 64.1741 60.1896 65.0134 59.7843C65.6316 60.5294 66.2017 61.3132 66.7201 62.1309C67.0401 62.6109 67.3334 63.0909 67.6001 63.5709C67.8934 64.0776 68.1867 64.5576 68.4534 65.0909C69.1056 66.3308 69.6498 67.6244 70.0801 68.9576C70.1023 69.0717 70.147 69.1802 70.2115 69.2769C70.2759 69.3736 70.3589 69.4565 70.4556 69.521C70.5523 69.5855 70.6608 69.6301 70.7748 69.6524C70.8889 69.6747 71.0062 69.6742 71.1201 69.651C71.2358 69.6322 71.3465 69.5897 71.4451 69.5262C71.5437 69.4627 71.6282 69.3796 71.6933 69.282C71.7583 69.1844 71.8026 69.0744 71.8233 68.959C71.8439 68.8435 71.8406 68.725 71.8134 68.6109C71.7907 67.0527 71.5758 65.5032 71.1734 63.9976Z"
                  fill="#FF9E67"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M50.4818 34.6658C50.3938 33.1002 50.1162 31.5511 49.6551 30.0524C49.4511 29.3924 49.1738 28.7574 48.8285 28.1591C48.5091 27.5376 48.1053 26.9632 47.6285 26.4524C46.9459 25.7434 46.1752 25.125 45.3351 24.6124C46.2656 23.6873 46.9856 22.5723 47.4458 21.3436C47.906 20.1148 48.0957 18.8012 48.0018 17.4924C48.0021 16.3804 47.7802 15.2796 47.3491 14.2546C46.918 13.2296 46.2864 12.301 45.4915 11.5235C44.6966 10.7459 43.7543 10.135 42.7199 9.72672C41.6856 9.31841 40.5802 9.12089 39.4685 9.14576C37.0972 9.06585 34.7895 9.9214 33.0434 11.5278C31.2973 13.1342 30.2528 15.3627 30.1351 17.7324C30.0809 19.2252 30.4633 20.7015 31.2353 21.9803C32.0073 23.2591 33.1356 24.2851 34.4818 24.9324C33.3732 25.5065 32.3275 26.1947 31.3618 26.9858C30.41 27.7413 29.5822 28.6411 28.9085 29.6524C28.2972 30.5776 27.8784 31.6162 27.6768 32.7065C27.4752 33.7968 27.4951 34.9166 27.7351 35.9991C27.7745 36.2305 27.9021 36.4377 28.0911 36.5769C28.2801 36.7162 28.5158 36.7767 28.7485 36.7458C28.9782 36.7066 29.183 36.5779 29.318 36.388C29.453 36.198 29.5071 35.9622 29.4685 35.7324C29.4876 34.5033 29.8679 33.307 30.5618 32.2924C31.235 31.3443 31.9841 30.4525 32.8018 29.6258C34.0818 28.1858 35.4685 26.7724 36.5618 25.6791C37.3682 25.8598 38.1894 25.9669 39.0151 25.9991C39.2202 25.9991 39.4169 25.9176 39.562 25.7726C39.707 25.6276 39.7885 25.4309 39.7885 25.2258C39.7885 25.0207 39.707 24.824 39.562 24.6789C39.4169 24.5339 39.2202 24.4524 39.0151 24.4524C34.4285 23.9991 32.4018 20.9058 32.6418 17.8658C32.8238 16.1985 33.6452 14.6667 34.9332 13.5926C36.2213 12.5184 37.8756 11.9854 39.5485 12.1058C41.0534 12.0982 42.5015 12.68 43.583 13.7265C44.6644 14.7731 45.2933 16.2014 45.3351 17.7058C45.6498 19.2755 45.3299 20.906 44.4453 22.2404C43.5607 23.5747 42.1835 24.5044 40.6151 24.8258C40.5012 24.8353 40.3906 24.8683 40.2901 24.9227C40.1896 24.9771 40.1015 25.0518 40.0313 25.142C39.9611 25.2323 39.9104 25.336 39.8824 25.4468C39.8544 25.5576 39.8496 25.673 39.8685 25.7858C39.8953 26.0147 40.0109 26.224 40.1904 26.3686C40.3699 26.5132 40.599 26.5816 40.8285 26.5591C41.7591 26.4768 42.6648 26.2141 43.4951 25.7858C44.1223 26.5333 44.6928 27.3266 45.2018 28.1591C45.5218 28.6391 45.8151 29.1191 46.0818 29.5991C46.3751 30.0791 46.6685 30.5858 46.9351 31.0924C47.5962 32.3407 48.1494 33.6432 48.5885 34.9858C48.6396 35.2074 48.7722 35.4016 48.9599 35.5301C49.1476 35.6585 49.3767 35.7117 49.6018 35.6791C49.7281 35.6763 49.8525 35.647 49.9669 35.5933C50.0813 35.5396 50.1832 35.4626 50.266 35.3671C50.3489 35.2717 50.4109 35.16 50.448 35.0393C50.4852 34.9185 50.4967 34.7912 50.4818 34.6658Z"
                  fill="#FF9E67"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M47.0941 55.4646C45.3161 56.2304 43.4672 56.8199 41.5741 57.2246C40.3904 57.4891 39.1858 57.6498 37.9741 57.7046C35.954 57.9041 33.9204 57.4955 32.1341 56.5313C31.9644 56.4111 31.7538 56.3632 31.5488 56.3982C31.3437 56.4332 31.161 56.5482 31.0408 56.718C30.9205 56.8877 30.8727 57.0982 30.9077 57.3033C30.9427 57.5083 31.0577 57.6911 31.2274 57.8113C33.0836 59.5154 35.4832 60.5073 38.0008 60.6113C39.4779 60.6515 40.9503 60.4257 42.3474 59.9446C44.3579 59.22 46.2599 58.2241 48.0008 56.9846C48.1179 56.9388 48.2239 56.8683 48.3116 56.778C48.3992 56.6877 48.4664 56.5797 48.5087 56.4612C48.5511 56.3427 48.5675 56.2165 48.5569 56.0911C48.5463 55.9657 48.509 55.8441 48.4474 55.7344C48.3858 55.6246 48.3014 55.5294 48.1998 55.4551C48.0983 55.3808 47.982 55.3291 47.8588 55.3035C47.7356 55.2779 47.6084 55.2791 47.4857 55.3069C47.3629 55.3347 47.2476 55.3885 47.1474 55.4646H47.0941Z"
                  fill="#FF9E67"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.5079 38.0776C16.7354 38.0205 16.9319 37.8776 17.0562 37.6787C17.1806 37.4798 17.223 37.2404 17.1745 37.0109C17.0124 35.4071 17.1572 33.7872 17.6012 32.2376C17.7693 31.5953 17.974 30.9631 18.2145 30.3442C18.4545 29.7309 18.7212 29.1176 19.0145 28.5309C19.6475 27.095 20.6393 25.8461 21.8945 24.9042C22.0784 24.8088 22.2168 24.6442 22.2793 24.4466C22.3419 24.2491 22.3233 24.0348 22.2279 23.8509C22.1324 23.667 21.9678 23.5286 21.7702 23.4661C21.5727 23.4036 21.3584 23.4221 21.1745 23.5176C19.3313 24.2251 17.7364 25.4583 16.5879 27.0642C16.1044 27.7642 15.7186 28.5268 15.4412 29.3309C15.1549 30.1151 14.9581 30.9292 14.8545 31.7576C14.655 33.6378 14.8642 35.539 15.4679 37.3309C15.4838 37.4497 15.5239 37.564 15.5856 37.6668C15.6473 37.7696 15.7294 37.8587 15.8268 37.9286C15.9242 37.9985 16.0348 38.0478 16.1519 38.0734C16.2691 38.099 16.3902 38.1004 16.5079 38.0776Z"
                  fill="#FF9E67"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M59.9476 28.2117C60.2302 28.8685 60.462 29.5461 60.6409 30.2384C61.2507 32.7155 60.9772 35.3278 59.8676 37.625C59.8117 37.7245 59.7763 37.8341 59.7636 37.9474C59.7508 38.0608 59.7608 38.1755 59.7931 38.2849C59.8255 38.3943 59.8794 38.4961 59.9517 38.5843C60.0241 38.6725 60.1133 38.7453 60.2143 38.7984C60.3157 38.8548 60.4274 38.8906 60.5427 38.9038C60.6581 38.9169 60.7749 38.9071 60.8865 38.8748C60.998 38.8426 61.1021 38.7886 61.1927 38.716C61.2832 38.6434 61.3586 38.5536 61.4143 38.4517C62.6563 36.6685 63.4435 34.6087 63.7076 32.4517C63.8155 31.4806 63.7615 30.4984 63.5476 29.545C63.3297 28.5986 62.9509 27.6965 62.4276 26.8784C61.2018 25.0967 59.5763 23.6264 57.6809 22.585C57.5131 22.4659 57.3058 22.4161 57.1022 22.4459C56.8986 22.4757 56.7143 22.5828 56.5876 22.745C56.5253 22.8269 56.4799 22.9204 56.4542 23.0201C56.4285 23.1197 56.4229 23.2235 56.4378 23.3253C56.4527 23.4271 56.4878 23.525 56.541 23.6131C56.5942 23.7012 56.6644 23.7778 56.7476 23.8384C58.0915 25.0715 59.1789 26.5576 59.9476 28.2117Z"
                  fill="#FF9E67"
                />
              </svg>
            </div>
            <div className="right">
              <h2>Here's what to expect</h2>
              <p>
                In this activity, you'll come prepared with a coaching topic
                that you want input on.
              </p>
              <h5>Here's what to do before your next session:</h5>
              <div className="icons">
                <div className="item">
                  <span>1</span>
                  <div className="content">
                    <h4>
                      Think of a challenge you're facing at work. If you can't
                      think of one, think of a challenge you're anticipating.
                    </h4>
                  </div>
                </div>
                <div className="item">
                  <span>2</span>
                  <div className="content">
                    <h4>
                      Think about why it's important. What's the impact on you,
                      your colleagues, and the company?
                    </h4>
                  </div>
                </div>
                <div className="item">
                  <span>3</span>
                  <div className="content">
                    <h4>
                      Think about what you'd like to walk away with at the end
                      of the session. Are you looking for more ideas? Different
                      perspectives? Clarity about something? Confidence?
                    </h4>
                  </div>
                </div>
              </div>

              <div className="actions">
                <button
                  className="btn secondary"
                  onClick={() => {
                    setShowIntro(false);
                  }}
                >
                  Let's Begin
                </button>
              </div>
            </div>
          </div>
          <div
            className="skrim"
            onClick={() => {
              setShowIntro(false);
            }}
          ></div>
        </div>
      )}
    </div>
  );
};
